/**
 * Load JSON file asynchronously, parse and return as JS object.
 * TODO: any error handling.
 * @param {String} path Path or URL to 
 * @param {*} container 
 */
export const loadAndParseJSON = async (path) => {
    return await fetch(path)
        .then(async res => {
            return await res.json().then(async data => {
                // container = data;
                return await data;
            })
        }).catch(err => {
            console.error(err);
        })
}





/**
 * Write Movie/TV show title to every DOM with .title class attached.
 * @param {String} title 
 */
export const setTitlesInText = title => {
    const QUERY_TITLE = '.title';
    const els = document.querySelectorAll(QUERY_TITLE);
    els.forEach(el => {
        el.innerHTML = title;
    })
}






/**
 * Set years in YYYY format
 */
export const setYears = () => {
    const doms = document.querySelectorAll('.yyyy');
    const currentFullYear = new Date().getFullYear();
    doms.forEach(dom => {
        dom.innerHTML = currentFullYear;
    })
}




/**
 * Check if current browser is phone or not.
 */
export const isPhone = () => {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        // || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
    ){
        return true;
    }

    return false;
}